<div [formGroup]="salesInformationFormGroup">
    <h2 class="page-header" id="sales">Sales Information <small class="text-danger">Required if Submitting to Workflow</small></h2>
    <hr />
    <div class="mb-3 row">
        <label for="estAnnualCreditCardSalesVol" class="col-5 col-form-label text-end">Estimated Annual Credit Card Sales Volume</label>
        <div class="col">
            <div class="input-group">
                <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'dollar-sign']"></fa-icon>
                </span>
                <input type="number" class="form-control" id="estAnnualCreditCardSalesVol" formControlName="estAnnualCreditCardSalesVol" [ngClass]="{ 'is-invalid': estAnnualCreditCardSalesVol.errors && showErrors }" maxlength="10" digitOnly>
            </div>
            <small id="estAnnualCreditCardSalesVolHelp" class="form-text">Max of 10 characters. Only integers are allowed.</small>
            <div *ngIf="estAnnualCreditCardSalesVol.invalid && showErrors" class="text-danger">
                <small *ngIf="estAnnualCreditCardSalesVol.errors.required">Estimated Annual Credit Card Sales Volume is required</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row">
        <label for="estAvgTransactionAmt" class="col-5 col-form-label text-end">Estimated Average Transaction Amount</label>
        <div class="col">
            <div class="input-group">
                <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'dollar-sign']"></fa-icon>
                </span>
                <input type="number" class="form-control" id="estAvgTransactionAmt" formControlName="estAvgTransactionAmt" [ngClass]="{ 'is-invalid': estAvgTransactionAmt.errors && showErrors }" maxlength="10" digitOnly>
            </div>
            <small id="estAvgTransactionAmtHelp" class="form-text">Max of 10 characters. Only integers are allowed.</small>
            <div *ngIf="estAvgTransactionAmt.invalid && showErrors" class="text-danger">
                <small *ngIf="estAvgTransactionAmt.errors.required">Estimated Average Transaction Amount is required</small>
            </div>
        </div>
    </div>
    <div class="mb-3 row" formGroupName="cardAcceptanceChannels">
        <label class="col-5 col-form-label text-end">Card Acceptance Channels</label>
        <div class="col">
            <div class="row">
                <div class="col-4">
                    <div class="input-group">
                        <span class="input-group-text">
                            <fa-icon [icon]="['fas', 'percent']"></fa-icon>
                        </span>
                        <input type="number" class="form-control" id="inPersonCardAcceptanceChannel" formControlName="inPersonCardAcceptanceChannel" [ngClass]="{ 'is-invalid': showErrors && (inPersonCardAcceptanceChannel.errors || (cardAcceptanceChannels.errors && cardAcceptanceChannels.errors.totalNot100)) }" maxlength="3" digitOnly>
                    </div>
                    <div class="text-center">
                        <small id="inPersonCardAcceptanceChannelHelp">In Person (Card Present)</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="input-group">
                        <span class="input-group-text">
                            <fa-icon [icon]="['fas', 'percent']"></fa-icon>
                        </span>
                        <input type="number" class="form-control" id="mailTelephoneCardAcceptanceChannel" formControlName="mailTelephoneCardAcceptanceChannel" [ngClass]="{ 'is-invalid': showErrors && (mailTelephoneCardAcceptanceChannel.errors || (cardAcceptanceChannels.errors && cardAcceptanceChannels.errors.totalNot100)) }" maxlength="3" digitOnly>
                    </div>
                    <div class="text-center">
                        <small id="mailTelephoneCardAcceptanceChannelHelp">Mail/Telephone Order (Card Not Present)</small>
                    </div>
                </div>
                <div class="col-4">
                    <div class="input-group">
                        <span class="input-group-text">
                            <fa-icon [icon]="['fas', 'percent']"></fa-icon>
                        </span>
                        <input type="number" class="form-control" id="websiteCommerceCardAcceptanceChannel" formControlName="websiteCommerceCardAcceptanceChannel" [ngClass]="{ 'is-invalid': showErrors && (websiteCommerceCardAcceptanceChannel.errors || (cardAcceptanceChannels.errors && cardAcceptanceChannels.errors.totalNot100)) }" maxlength="3" digitOnly>
                    </div>
                    <div class="text-center">
                        <small id="websiteCommerceCardAcceptanceChannelHelp">Website/eCommerce Order (Card Not Present)</small>
                    </div>
                </div>
            </div>
            <div *ngIf="inPersonCardAcceptanceChannel.invalid && showErrors" class="text-danger">
                <small *ngIf="inPersonCardAcceptanceChannel.errors.required">In Person (Card Present) is required</small>
            </div>
            <div *ngIf="mailTelephoneCardAcceptanceChannel.invalid && showErrors" class="text-danger">
                <small *ngIf="mailTelephoneCardAcceptanceChannel.errors.required">Mail/Telephone Order (Card Not Present) is required</small>
            </div>
            <div *ngIf="websiteCommerceCardAcceptanceChannel.invalid && showErrors" class="text-danger">
                <small *ngIf="websiteCommerceCardAcceptanceChannel.errors.required">Website/eCommerce Order (Card Not Present) is required</small>
            </div>
            <div *ngIf="cardAcceptanceChannels.invalid && cardAcceptanceChannels.errors && showErrors" class="text-danger">
                <small *ngIf="cardAcceptanceChannels.errors.totalNot100">Card Acceptance Channel percentages must equal 100</small>
            </div>
        </div>
    </div>
</div>
